import React, { Component } from 'react';
import * as $ from 'jquery';
import { saveAs } from 'file-saver';
import * as CookieService from '../CookieService';
import { withTranslation, Trans } from 'react-i18next'
class PDFPreviewComponent extends Component {
    constructor(props) {
        super(props);
    }

    CLosepopup = () => {
        if (localStorage.getItem("isFromLink") != "true") {
            if (this.props.PdfPage == "1") {
                this.props.history.push({
                    pathname: `\HomePage`,
                });
            }
            if (this.props.PdfPage == "2") {
                this.props.history.push({
                    pathname: `/receiving`,
                });
            }
        }
    }
    downloadPDF = (e) => {
        e.preventDefault();
        let sliceSize = 512
        const byteCharacters = atob(this.props.base64URL.split(',')[1]);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: "application/pdf" });
        let Filename = "SDIOrderStatusReport.pdf"

        if (this.props.pdfTitle == "Purchase Order Report") {
            Filename = "Purchase Order Report"
        }
        if (this.props.pdfTitle == "Delivery Ticket Report") {
            Filename = "Delivery Ticket Report"
        }
        if (this.props.pdfTitle == "Container bar code labels report") { //CPW-99 Download pdf name -Vishwa S
            Filename = "Container Bar Code Labels Report"
        }
        saveAs(blob, Filename);
    }
    render() {
        
        console.log("PDF", this.props.base64URL)
        return (
            <div className="modal-dialog modal-xl custom-popup modal-dialog-centered">
                <div className="modal-content">
                    {/* Modal Header */}
                    <div className="modal-header">
                        <h4 className="modal-title mt-1">{this.props.pdfTitle}</h4>
                        <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.CLosepopup()}>
                            X
                     </button>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="col-md-12 float-left p-0" id="pdfBody">
                            {/*  <a href={this.props.base64URL} className="float-right" title="Download" download="SDIOrderStatusReport.pdf">Download</a> */}
                            {localStorage.getItem("isFromLink") != "true" ? <a href="#" className="float-right" title="Download" onClick={(e) => this.downloadPDF(e)}><Trans>Download</Trans></a> : null}
                            <object className="pdf-preview custom-scroll" data={this.props.base64URL} type="application/pdf" ></object>
                        </div>
                    </div>
                </div>
            </div>);
    }
}
export default withTranslation()(PDFPreviewComponent);


